/**
 * Resolves MongoDB `locations._id` for recommendation writes and similar APIs.
 *
 * List/post payloads often use `location_id` (snake_case) without `_id`; timeline
 * places may only set top-level `locationId`. The `Location` model constructor only
 * maps `data._id`, so callers should normalize with this helper before constructing
 * `Location` or passing `locationId` to `POST /api/v1/recommendation`.
 */

function coalesceId(value: unknown): string {
  if (typeof value === 'string' && value.trim().length > 0) return value.trim();
  if (typeof value === 'number' && Number.isFinite(value)) return String(value);
  return '';
}

export function getCanonicalLocationMongoId(input: {
  _id?: unknown;
  location_id?: unknown;
  locationId?: unknown;
}): string {
  return coalesceId(input._id) || coalesceId(input.location_id) || coalesceId(input.locationId);
}
